<template>
  <ModalBase @close-modal="() => closeNotEntryModal()">
    <div class="cnt">
      <p class="lead">
        <strong v-html="lead" />
      </p>
      <p v-html="text" />
      <div class="limitedModalButton">
        <template v-if="btnLabel === 'ログイン'">
          <p class="btn">
            <Button
              :href="`/register/user_category?q=${btnLink}`"
              label="会員登録する"
              :handleClick="
                () => {
                  $store.commit('unFixBody')
                  $router.push(`/register/user_category?q=${btnLink}`)
                }
              "
              secondary
            />
          </p>
          <p class="btn">
            <Button
              :href="`/login?q=${btnLink}`"
              label="ログイン"
              :handleClick="
                () => {
                  $store.commit('unFixBody')
                  $router.push(`/login?q=${btnLink}`)
                }
              "
              primary
              border
            />
          </p>
        </template>
        <template v-if="btnLabel !== 'ログイン'">
          <p class="btn">
            <Button
              :href="btnLink"
              :label="btnLabel"
              :handleClick="
                () => {
                  $store.commit('unFixBody')
                  $router.push(btnLink)
                }
              "
              secondary
            />
          </p>
        </template>
      </div>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import ModalBase from '@/components/genenral/ModalBase.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'ModalEventNotEntry',

  components: {
    ModalBase,
    Button
  },

  props: {
    lead: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    btnLabel: {
      type: String,
      required: true
    },
    btnLink: {
      type: String,
      required: true
    },
    closeNotEntryModal: {
      type: Function as PropType<() => void>,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.cnt {
  padding-left: 20px;
  padding-right: 20px;

  @include mixins.media() {
    padding-left: 50px;
    padding-right: 50px;
  }
}

.lead {
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: var.$color-main;

  &::before {
    content: '';
    display: block;
    width: 75px;
    height: 75px;
    margin: 0 auto 10px;
    background: url('~@/assets/images/icon/user2.svg') no-repeat;
    background-size: 100% 100%;

    @include mixins.media() {
      margin-bottom: 20px;
    }
  }

  > strong {
    font-weight: inherit;
  }

  & + p {
    margin-top: 10px;

    @include mixins.media() {
      margin-top: 20px;
      text-align: center;
    }
  }
}

.limitedModalButton {
  margin-top: 30px;

  @include mixins.media() {
    display: flex;
    justify-content: center;

    .btn {
      width: 215px;
    }
  }

  .btn:not(:first-child) {
    margin-top: 20px;

    @include mixins.media() {
      margin-top: 0;
      margin-left: 16px;
    }
  }
}

::v-deep(.button) {
  max-width: none;
}
</style>
